import {
  CheckOutlined,
  ClearOutlined,
  Close,
  GroupWorkOutlined,
} from "@mui/icons-material";
import {
  Button,
  DialogContentText,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useCallback, useEffect } from "react";
import { useModal } from "../../context/modal-context";
import { useParts } from "../../context/part-context";
import useInput from "../../hooks/use-input";
import { getTitleForModal } from "../../services/helpers";
import NTSModal from "../UI/NTSModal";
import NTSModalFooter from "../UI/NTSModalFooter";

const PartTypeModal = () => {
  const { modalState, closeModal } = useModal();
  const { partTypes, addPartType, editPartType, removePartType } = useParts();

  const {
    value: nameValue,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    valueBlurHandler: nameBlurHandler,
    valueResetHandler: nameResetHandler,
    setValueHandler: setNameHandler,
  } = useInput((value) => value.trim().length > 3);

  const resetForm = useCallback(() => {
    nameResetHandler();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    resetForm();
    if (
      !modalState.type ||
      modalState.type === "add" ||
      modalState.model !== "partType"
    )
      return;

    const partType = partTypes.find((type) => type.id === modalState.id);
    setNameHandler(partType?.name);
    // eslint-disable-next-line
  }, [modalState]);

  const submitHandler = (event) => {
    event.preventDefault();
    closeModal();
    const partTypeObj = {
      name: nameValue,
    };
    if (modalState.type === "add") {
      addPartType(partTypeObj);
    }
    if (modalState.type === "edit") {
      editPartType(modalState.id, partTypeObj);
    }
    if (modalState.type === "delete") {
      removePartType(modalState.id);
    }
    resetForm();
  };

  let title = "";
  let buttons = (
    <>
      <Button onClick={closeModal} endIcon={<ClearOutlined />} color="error">
        Cancel
      </Button>
      <Button
        onClick={submitHandler}
        disabled={!nameIsValid}
        endIcon={<CheckOutlined />}
        color="success"
      >
        Submit
      </Button>
    </>
  );

  if (modalState.open && modalState.type) {
    title = getTitleForModal(modalState.type);
  }
  if (modalState.type === "view") {
    buttons = (
      <Button onClick={closeModal} endIcon={<Close />} color="primary">
        Close
      </Button>
    );
  }

  return (
    modalState.open &&
    modalState.model === "partType" && (
      <NTSModal title={`${title} PART TYPE`} maxWidth="xs">
        {modalState.type === "delete" ? (
          <DialogContentText>{`Are you sure that you want to remove part type ${nameValue}?`}</DialogContentText>
        ) : (
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Part type name"
            name="name"
            disabled={modalState.type === "view"}
            value={nameValue}
            onChange={nameChangeHandler}
            onBlur={nameBlurHandler}
            error={nameHasError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <GroupWorkOutlined />
                </InputAdornment>
              ),
            }}
          />
        )}
        <NTSModalFooter
          sx={{
            display: "flex",
            justifyContent: "end",
            marginY: 2,
          }}
        >
          {buttons}
        </NTSModalFooter>
      </NTSModal>
    )
  );
};

export default PartTypeModal;
